import { useMutation, useQuery, useQueryClient, UseQueryResult } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
    getUserStationPreferences,
    updateUserStationPreferences,
} from "./stationPreferencesService";
import {
    GetUserStationPreferencesResponse,
    UpdateUserStationPreferencesRequest,
} from "./stationPreferencesTypes";

export const useGetUserStationPreferences = (
    enabled: boolean = true
): UseQueryResult<GetUserStationPreferencesResponse> => {
    return useQuery({
        queryKey: ["userStationPreferences"],
        queryFn: getUserStationPreferences,
        onError: () => {
            toast.error("Greška pri dohvaćanju postavki stanica");
        },
        enabled,
    });
};

export const useUpdateUserStationPreferences = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, UpdateUserStationPreferencesRequest>({
        mutationFn: updateUserStationPreferences,
        onSuccess: () => {
            toast.success("Postavke stanica su uspješno ažurirane");
            queryClient.invalidateQueries({ queryKey: ["userStationPreferences"] });
        },
        onError: (error: any) => {
            const errorMessage = error?.response?.data || "Greška pri ažuriranju postavki stanica";
            toast.error(errorMessage);
        },
    });
};
